var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4888 20.019C26.4888 21.8504 28.0707 23.341 29.9957 23.341C29.9957 28.6648 28.593 29.9994 22.9968 29.9994H8.99893C3.40277 29.9994 2 28.6648 2 23.341V22.688C3.92508 22.688 5.50693 21.1831 5.50693 19.3517C5.50693 17.5203 3.92508 16.0155 2 16.0155V15.3624C2.01492 10.0386 3.40277 8.7041 8.99893 8.7041H22.9819C28.578 8.7041 29.9808 10.0386 29.9808 15.3624V16.6969C28.0557 16.6969 26.4888 18.1734 26.4888 20.019Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4611 8.70446H8.896L13.2685 4.54478C16.8351 1.15174 18.6259 1.15174 22.1925 4.54478L23.0879 5.39659C22.1477 6.291 21.9239 7.6113 22.4611 8.70446Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0115 8.70483V30.0002",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "166.67 166.67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketManagement);
export default __webpack_public_path__ + "static/media/ticket_management.422508a45bedfcbb77192f1319731998.svg";
export { ForwardRef as ReactComponent };